import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index() {
  // console.log("redirecting to dashboard from index route");
  return <Navigate to="/dashboard" />;
}
